module.exports = __webpack_public_path__ + "img/i_homework-file.2ad3c22d.svg";